import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Css/FeaturedCollection.module.css";
import { collectionsData } from "../../data/collectionData";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const FeaturedCollections = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const backgroundImages = [
    "/images/featured/garhwali.webp",
    "/images/love.webp",
    "/images/featured/horror.webp",
    "/images/featured/crime.webp",
    "/images/featured/kids.webp",
  ];

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Featured Collections</h2>

      <div className={styles.swiperWrapper}>
        <Swiper
          grabCursor={isMobile} // only enable grab icon on mobile

          freeMode={true}
          modules={[FreeMode, Mousewheel]}
          mousewheel={
            !isMobile
              ? {
                  forceToAxis: true,
                  sensitivity: 1.5,
                  releaseOnEdges: true,
                }
              : false
          }
          speed={400}
          className={styles.swiper}
          breakpoints={{
            320: {
              slidesPerView: 1.5,
              spaceBetween: 8,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 8,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 12,
            },
          }}
        >
          {collectionsData.map((collection, index) => (
            <SwiperSlide key={collection.id}>
              <div
                onClick={() => navigate(`/collection/${collection.link}`)}
                className={styles.card}
                style={{
                  backgroundImage: `url(${backgroundImages[index % backgroundImages.length]})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
      
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default FeaturedCollections;
